export const INTEGRATION_KEY = {
  INTEGRATION_KEY_TITLE: { key: 'INTEGRATION_KEY_TITLE', value: 'Api Integration Key' },
  ENTERPRISE_INTEGRATION_KEY_TITLE: { key: 'ENTERPRISE_INTEGRATION_KEY_TITLE', value: 'Integration Key' },

  API_KEY_LABEL: { key: 'API_KEY_LABEL', value: 'API Key' },

  REGENERATION_WARNING_MESSAGE: {
    key: 'REGENERATION_WARNING_MESSAGE',
    value:
      'Here is the API key provided for your integration with third-party systems. You have the option to generate a new key by clicking the "regenerate" button. Keep in mind that once the key is regenerated, the old key will no longer be functional.',
  },
  REGENERATE_CONFIRMATION_MESSAGE: {
    key: 'REGENERATE_CONFIRMATION_MESSAGE',
    value:
      'Should you opt to regenerate the key, please be aware that the previous key will become invalid and cease to function. Would you like to proceed with this action?',
  },
  COPIED_SUCCESS_MESSAGE: { key: 'COPIED_SUCCESS_MESSAGE', value: 'Copied' },
  REGENERATED_SUCCESS_MESSAGE: {
    key: 'REGENERATED_SUCCESS_MESSAGE',
    value: 'The API key has been regenerated successfully.',
  },

  LOADING_TEXT: { key: 'LOADING_TEXT', value: 'Loading' },

  COPY_CLIPBOARD_TOOLTIP: { key: 'COPY_CLIPBOARD_TOOLTIP', value: 'Copy to clipboard' },

  COPY_BUTTON: { key: 'COPY_BUTTON', value: 'Copy' },
  REGENERATE_BUTTON: { key: 'REGENERATE_BUTTON', value: 'Regenerate API Key' },
  REGENERATING_BUTTON: { key: 'REGENERATING_BUTTON', value: 'Regenerating' },
  PROCEED_BUTTON: { key: 'PROCEED_BUTTON', value: 'Proceed' },

  // Key Rotation Card
  KEY_ROTATION_TITLE: { key: 'KEY_ROTATION_TITLE', value: 'Key Rotation' },
  KEY_ROTATION_DETAILS: { key: 'KEY_ROTATION_DETAILS', value: 'Your key automatically rotates every' },
  KEY_ROTATION_DAYS: { key: 'KEY_ROTATION_DAYS', value: 'days' },
  KEY_EXPIRES_ON: { key: 'KEY_EXPIRES_ON', value: 'Expires on' },
  DAYS_REMAINING: { key: 'DAYS_REMAINING', value: 'days remaining' },

  // Visibility toggle
  SHOW_KEY_TOOLTIP: { key: 'SHOW_KEY_TOOLTIP', value: 'Show' },
  HIDE_KEY_TOOLTIP: { key: 'HIDE_KEY_TOOLTIP', value: 'Hide' },

  // Embed tab specific
  EMBED_WARNING_MESSAGE: {
    key: 'EMBED_WARNING_MESSAGE',
    value: 'The authentication key will be used to securely integrate Perfect Doc Studio. You can regenerate a new key by clicking the regenerate button. Please note that once a new key is generated, the previous one will no longer be valid',
  },
};
